import Script from 'next/script';

function ImpactTracker() {
  return (
    <Script
      src="https://d.impactradius-event.com/A2401526-017e-4c8d-92bb-c12c27d322271.js"
      strategy="afterInteractive"
      id="impact-tracker"
    />
  );
}

export default ImpactTracker;
